import { NodeSpec } from 'prosemirror-model';

export const imageNodeSchema: NodeSpec = {
  inline: true,
  attrs: {
    src: {},
    position: { default: 'block' },
  },
  group: 'inline',
  draggable: true,
  parseDOM: [
    {
      tag: 'img[src]',
      getAttrs(dom) {
        return {
          src: (dom as HTMLElement).getAttribute('src'),
          position: (dom as HTMLElement).getAttribute('data-position'),
        };
      },
    },
  ],
  toDOM(node) {
    return [
      'img',
      { src: node.attrs.src, 'data-position': node.attrs.position },
    ];
  },
};
